﻿import { useState } from 'react';

const LogoutConfirmationModal = ({ onConfirm, onCancel, isCheckedIn }) => {
  const [isOpen, setIsOpen] = useState(true);

  const handleConfirm = () => {
    onConfirm();
    setIsOpen(false); // Close modal after confirming
  };

  const handleCancel = () => {
    onCancel();
    setIsOpen(false); // Close modal after canceling
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center">
        {/* Overlay */}
        <div className="fixed inset-0 bg-black bg-opacity-40 transition-opacity"></div>

        {/* Modal Content */}
        <div className="relative inline-block w-full max-w-md p-8 my-8 bg-white rounded-xl shadow-lg border border-gray-200 transform transition-all z-10">
          <div className="text-center mb-6">
            <h3 className="text-2xl font-semibold text-gray-800">Confirm Logout</h3>
            <p className="text-sm text-gray-600 mt-2">Are you sure you want to log out?</p>

            {/* Conditional message based on check-in status */}
            {isCheckedIn && (
              <p className="text-sm text-red-600 mt-3">
                You are currently checked in. If you log out, you will be automatically checked out.
              </p>
            )}
          </div>

          <div className="flex justify-center space-x-6 mt-6">
            <button
              onClick={handleCancel}
              className="px-6 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300 transition-colors duration-200"
            >
              Cancel
            </button>

            <button
              onClick={handleConfirm}
              className="px-6 py-2 text-white bg-red-500 hover:bg-red-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 transition-colors duration-200"
            >
              Log Out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoutConfirmationModal;
